import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { message } from "antd";
import Layout from "../components/Layout/Layout";
import DashboardLayout from "../user/components/DashboardLayout";
import HeroSvg from "../components/Layout/HeroSvg";
import {
  ChevronLeftSvg,
  ListSvg,
} from "../components/AllSvgModulesExport/LoginSvg";
import { useLocation, useNavigate } from "react-router-dom";
import { setActiveButton } from "../redux/features/footerMenuSlice";
import "./PaymentHistory.css";
import "./Reports.css";
import SideMenu from "../components/Header/SideMenu";
import CancelIcon from "@mui/icons-material/Cancel";
import { apiClient } from "../config/api.client";

const PaymentHistory = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const { user } = useSelector((state) => state.user);
  const [payments, setPayments] = useState([]);
  const [sideMenu, setSideMenu] = useState(false);
  const initialType = queryParams.get("type");
  const active = initialType === "purchase" ? 1 : 0;
  const [tab, setTab] = useState(active);
  const [loading, setLoading] = useState(false);

  // orders
  const [allOrders, setAllOrders] = useState([]);
  const [orderPop, setOrderPop] = useState(null);

  // getting user payments (transactions history)
  async function getUserPayments() {
    try {
      const endDate = new Date();
      const startDate = new Date();
      startDate.setDate(endDate.getDate() - 7);

      const res = await apiClient.get("/transaction/history", {
        params: {
          startDate: startDate.toISOString(),
          endDate: endDate.toISOString(),
          page: 1,
          limit: 50,
        },
      });
      if (res.data?.success) {
        const mapped = (res.data.transactions || []).map((t) => ({
          type: t?.status || "",
          amount: t?.amount,
          txnId: t?.txnId || t?.utr || t?.gatewayOrderId || t?.orderId,
          createdAt: t?.createdAt,
        }));
        setPayments(mapped);
      }
    } catch (error) {
      console.log(error);
    }
  }

  // get user orders
  const getAllUserOrders = async () => {
    try {
      setLoading(true);
      const endDate = new Date();
      const startDate = new Date();
      startDate.setDate(endDate.getDate() - 7);

      const res = await apiClient.get("/order/history", {
        params: {
          startDate: startDate.toISOString(),
          endDate: endDate.toISOString(),
          page: 1,
          limit: 50,
        },
      });
      if (res.data?.success) {
        const mapped = (res.data.orders || []).map((o) => {
          let parsedDesc = null;
          try {
            parsedDesc = o?.description ? JSON.parse(o.description) : null;
          } catch (e) {
            parsedDesc = null;
          }
          const firstItem = Array.isArray(o?.items) && o.items.length > 0 ? o.items[0] : null;
          return {
            orderId: o?.orderId,
            pname: firstItem?.itemName || "",
            price: firstItem?.price ?? o?.amount,
            userId: parsedDesc?.playerId || "",
            zoneId: parsedDesc?.server || "",
            paymentMode: o?.paymentMethod,
            status: o?.status,
            createdAt: o?.createdAt,
            discountedPrice: undefined,
          };
        });
        setAllOrders(mapped);
        setLoading(false);
      } else {
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };

  useEffect(() => {
    if (user !== null) {
      getAllUserOrders();
      getUserPayments();
    }
  }, [user]);

  const onClose = () => {
    dispatch(setActiveButton("home"));
    navigate("/");
    localStorage.setItem("activeButton", "home");
  };

  function getOrderStatus(value) {
    switch (value) {
      case "pending":
        return "text-warning";
      case "failed":
        return "text-danger";
      case "cancelled":
        return "text-danger";
      case "processing":
        return "text-primary";
      case "success":
        return "text-success";
      case "refunded":
        return "text-primary";
      default:
        return "text-dark";
    }
  }

  return (
    <Layout>
      <DashboardLayout>
        {/* MOBILE  */}
        {/* MOBILE  */}
        {/* MOBILE  */}
        <div className={`account-modal-container d-lg-none d-md-none `}>
          <HeroSvg />
          <div className="account-modal-container-content">
            <div className="top-left-content">
              <div className="box-1 center" onClick={onClose}>
                <ChevronLeftSvg />
              </div>
              <h2 className="mb-0">Reports</h2>
            </div>
            <div
              className="top-right-content box-2 center"
              onClick={() => setSideMenu(!sideMenu)}
            >
              <ListSvg />
            </div>
          </div>
          <div className="report-container payment-containers d-block d-md-block d-lg-none">
            <div className="reports-tab-container">
              {/* <button className="active">Wallet</button> */}
              <button
                className={`${tab === 0 && "active"}`}
                onClick={() => setTab(0)}
              >
                Payments
              </button>
              <button
                className={`${tab === 1 && "active"}`}
                onClick={() => setTab(1)}
              >
                Purchase
              </button>
            </div>

            {tab === 0 && (
              <div className="reports-payments-container">
                {payments?.length === 0 ? (
                  <p className="text-center m-0">No Record Found</p>
                ) : (
                  payments?.map((item, index) => {
                    return (
                      <div className="payments w-100">
                        <div className="item">
                          <h5 className="fw-bold">
                            {item?.type.toUpperCase()}
                          </h5>
                          <span className="text-success">
                            <b>₹{item?.amount}</b>
                          </span>
                        </div>
                        <div className="item">
                          <span>
                            <small>{item?.txnId}</small>
                          </span>
                          <span className="text-muted">
                            <small>
                              {new Date(item?.createdAt).toLocaleString(
                                "default",
                                {
                                  day: "numeric",
                                  month: "numeric",
                                  year: "numeric",
                                  hour: "numeric",
                                  minute: "numeric",
                                  second: "numeric",
                                }
                              )}
                            </small>
                          </span>
                        </div>
                      </div>
                    );
                  })
                )}
              </div>
            )}

            {tab === 1 && (
              <div className="reports-order-container">
                <div className="orderhistory">
                  {allOrders &&
                    allOrders.map((item, index) => {
                      return (
                        <div
                          className="history"
                          onClick={() => setOrderPop(item)}
                        >
                          <div className="item">
                            <h4 className="m-0">{item?.pname}</h4>
                            <b>
                              <span>₹{item?.price}</span>
                            </b>
                          </div>
                          <div className="item">
                            <span className="text-muted">
                              <small>{item?.orderId}</small>
                            </span>
                            <span className="text-dark">
                              <small>
                                {item?.userId} {item?.zoneId && item?.zoneId}
                              </small>
                            </span>
                          </div>
                          {/* <div className="item">
                            <span className="text-muted">
                              <small>{item?.amount}</small>
                            </span>
                            <span className="text-primary">
                              <small>
                                Paid using{" "}
                                {item?.paymentMode === "onegateway"
                                  ? "UPI"
                                  : "WALLET"}
                              </small>
                            </span>
                          </div> */}
                          <div className="item">
                            <span className="text-success">
                              <small>
                                {new Date(item?.createdAt).toLocaleString(
                                  "default",
                                  {
                                    day: "numeric",
                                    month: "numeric",
                                    year: "numeric",
                                    hour: "numeric",
                                    minute: "numeric",
                                    second: "numeric",
                                  }
                                )}
                              </small>
                            </span>
                            <span className={`${getOrderStatus(item?.status)}`}>
                              <small>{item?.status}</small>
                            </span>
                          </div>
                        </div>
                      );
                    })}
                </div>
              </div>
            )}

            {orderPop && (
              <div className="order-pop" onClick={() => setOrderPop(null)}>
                <CancelIcon
                  className="icon"
                  onClick={() => setOrderPop(null)}
                />
                <table className="table table-white bg-white">
                  <thead>
                    <tr>
                      <td>Order Id</td>
                      <td>{orderPop?.orderId}</td>
                    </tr>
                    <tr>
                      <td>Date</td>
                      <td>
                        {new Date(orderPop?.createdAt).toLocaleString(
                          "default",
                          {
                            day: "numeric",
                            month: "long",
                            year: "numeric",
                          }
                        )}
                      </td>
                    </tr>
                    <tr>
                      <td>Product Name</td>
                      <td>{orderPop?.pname}</td>
                    </tr>
                    <tr>
                      <td>Order Details</td>
                      <td>{orderPop?.amount}</td>
                    </tr>
                    {orderPop?.inGameName && (
                      <tr>
                        <td>In Game Name</td>
                        <td>{orderPop?.inGameName}</td>
                      </tr>
                    )}
                    <tr>
                      <td>User ID</td>
                      <td>{orderPop?.userId}</td>
                    </tr>
                    {orderPop?.zoneId && (
                      <tr>
                        <td>Zone ID</td>
                        <td>{orderPop?.zoneId}</td>
                      </tr>
                    )}
                    <tr>
                      <td>Price</td>
                      <td>{orderPop?.price}</td>
                    </tr>
                    {orderPop?.discountedPrice && (
                      <tr>
                        <td>Discounted Price</td>
                        <td>{orderPop?.discountedPrice}</td>
                      </tr>
                    )}
                    <tr>
                      <td>Payment Mode</td>
                      <td>
                        Paid using{" "}
                        {orderPop?.paymentMode === "onegateway"
                          ? "UPI"
                          : "WALLET"}
                      </td>
                    </tr>
                    <tr>
                      <td>Status</td>
                      <td>{orderPop?.status}</td>
                    </tr>
                  </thead>
                </table>
              </div>
            )}
          </div>
        </div>

        <SideMenu sideMenu={sideMenu} setSideMenu={setSideMenu} />
      </DashboardLayout>
    </Layout>
  );
};

export default PaymentHistory;
